// My orders — this device's identity at this restaurant, across its
// stores: what was placed here, and what the counter linked to the same
// phone. The identity is anonymous until the number is verified at
// checkout; a verified number carries the history across devices.

import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router';
import { CHANNEL_LABEL, fetchMyOrders, money, type Order } from '../lib/api';

export function MyOrders() {
  const { rid, sid } = useParams() as { rid: string; sid: string };
  const [orders, setOrders] = useState<Order[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchMyOrders(rid).then(setOrders, (e) => setError(e instanceof Error ? e.message : 'Could not load your orders.'));
  }, [rid]);

  return (
    <div className="mo-page">
      <header className="co-head">
        <Link to={`/r/${rid}/s/${sid}/account`} className="co-backbtn" aria-label="Back to your account">‹</Link>
        <div><h1>My orders</h1></div>
      </header>
      {error && <div className="co-err" role="alert" style={{ margin: '0 14px' }}>{error}</div>}
      {orders === null && !error && <div className="loading">Looking…</div>}
      {orders?.length === 0 && (
        <div className="co-sec"><p style={{ fontSize: 14, color: 'var(--ink-2)' }}>Nothing yet — the menu awaits.</p></div>
      )}
      <div data-section="my-orders">
        {orders?.map((o) => (
          <Link key={o.orderId} to={`/r/${rid}/s/${sid}/orders/${o.orderId}`} className="co-sec mo-row" data-order={o.orderId}>
            <span className="mo-status">{o.status.replace(/_/g, ' ')}</span>
            <span className="mo-what">
              {CHANNEL_LABEL[o.collectionType]} · {o.docketLabel ? `Docket ${o.docketLabel}` : new Date(o.placedAt).toLocaleDateString('en-AU')} · {o.lines.length} {o.lines.length === 1 ? 'item' : 'items'}
            </span>
            <span className="mo-amt money">{money(o.grandTotalInCents)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
